














































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import ImportsInjectorMixin from "@/mixins/importsInjectorMixin";

// Enums/Data
import { ImportStatusCodes as ISC } from "@/data/enums/imports";

// Types
import { IImport } from "@/models/imports";

@Component({
  components: {
    "imports-list-item": () =>
      import("@/components/app/admin/imports/importListItem.vue")
  }
})
export default class ImportsListing extends Mixins(ImportsInjectorMixin) {
  // Methods

  public getImportRoute(importId: IImport["id"]) {
    return {
      name: "adminImport",
      params: {
        importId
      }
    };
  }

  // Computed

  public get skeletonSize() {
    const { data } = this.$importsData.table;
    if (data.length) return data.length;

    return this.$store.getters["ui/isMobile"] ? 2 : 5;
  }

  public get showEmptyState() {
    return !this.$importsData.isLoading && !this.$importsData.table.data.length;
  }

  public get showSkeletons() {
    return this.$importsData.isLoading || !this.$importsData.total;
  }

  public canDelete(statusCode) {
    return ![ISC.IN_PROGRESS, ISC.COMPLETE].includes(statusCode);
  }
}
